module.exports = __webpack_public_path__ + "img/pic_map_russia_S.55c66319.jpg";